"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findIndex;

function findIndex(assets, assetIdToFind) {
  return assets.findIndex(function (_ref) {
    var assetId = _ref.assetId;
    return assetIdToFind === assetId;
  });
}